// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pointer {\n  cursor: pointer;\n}\n.mode-switch {\n  height: 40px;\n}\n.custom-switch {\n  line-height: 40px;\n}\n.custom-switch .v-input__slot {\n  margin: 0 !important;\n}\n.custom-switch label {\n  font-size: 14px !important;\n}", ""]);
// Exports
module.exports = exports;
